import { FaceWomanProfileIcon } from './FaceWomanProfileIcon';

/**
 * author: Michael Irigoyen
 * id 144C6FB3-DBAC-4CA7-B07C-51265D8EE619
 * name face-woman-profile
 * version: 4.2.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/face-woman-profile.svg
 * tags
 * - People / Family 
 */
export const EmojiWomanProfileIcon = FaceWomanProfileIcon;
export default EmojiWomanProfileIcon